import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'search',
  standalone: true,
  pure: false,
})
export class FilterPipe implements PipeTransform {
  public transform(value, keys: string, term: string) {
    return (value || []).filter(item => keys.split(',').some(key => item.hasOwnProperty(key) && new RegExp(term, 'gi').test(item[key])));
  }
}

